export enum SelfOrderInvoiceFulfillmentTypesEnum {
  EAT_IN = 'EAT_IN',
  TAKE_AWAY = 'TAKE_AWAY',
}
